import type { BiometryResponse } from '~/utils/customer-register/Biometry'
import { useMutation } from '@tanstack/vue-query'
import { queryClient, queryKeys } from '~/queryClient'
import { sendCustomerBiometry } from '~/services-v2/contract-formalization-api/contract-formalization-api'
import useProject from '~/store-v2/projects/useProject'

export default function useCustomerBiometrySend(projectId: Ref<string>) {
  const { data: project } = useProject(projectId)
  const mutationFn = async (orderId?: string) => {
    const res = await sendCustomerBiometry(projectId.value, orderId)

    await queryClient.refetchQueries({ queryKey: queryKeys.CONTRACT_BIOMETRY.DATA(projectId.value) })

    return res
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.CONTRACT_BIOMETRY.SEND,
    retry: (failureCount, error: any) => {
      const status = error?.response?.status
      const reasonCode = error?.response?.data?.detail?.reason_code
      if (status === 422 || reasonCode === 'STORE_ORDER_USED_ANOTHER')
        return false
      return failureCount < 3
    },
    retryDelay: 1000,
    onSuccess: () => {
      queryClient.setQueryData<BiometryResponse>(queryKeys.CONTRACT_BIOMETRY.DATA(projectId.value), (oldData) => {
        if (!oldData)
          return oldData

        return {
          ...oldData,
          approval: 'waiting',
          biometry: { ...oldData.biometry, status: project.value?.selected_installments?.is_combo_connect ? 'waiting' : 'in_progress' },
          contract: { ...oldData.contract, status: 'waiting' },
          status: 'biometric_started',
        }
      })

      queryClient.invalidateQueries({
        queryKey: queryKeys.FINANCING.DETAILS(projectId.value),
      })
    },
  })
}
